import Chart from 'components/charts/Echart';
import { Spinner } from 'components/shared/loader/Spinner';
import { areas } from 'constants/constants';
import { Col, Row } from 'react-bootstrap';
import { numberToShortNumFormatter } from 'utils/utils';
import classes from './McoBanner.module.scss';
const McoGaugeChart = ({ customerDetails }) => {
  let chartData = [];

  customerDetails?.livesCoveredByBenefitType?.map((item, i) => {
    chartData.push({
      value: item.livesPercentage,
      name: item?.dimensionName,
      livesNumber: item.livesNumber,
    });
  });

  return (
    <Row className='g-0'>
      <Col
        md={5}
        className='h-100'>
        <Chart
          chartData={chartData}
          chartType={'gaugeChart'}
          legend={'legend'}
          isMultiChart={true}
          style={{ height: '100%', width: '100%' }}
        />
      </Col>
      <Col
        md={6}
        className='mt-1 text-nowrap'>
        <span className={`d-flex title__bold title__x-small ms-2`}>
          % | # Lives Covered by Benefit Type
        </span>
        <div className='ms-2 '>
          <span
            className={`${classes['chart-label']} d-flex align-items-center`}>
            <span className='d-flex align-items-center'>
              <div className={`${classes['circle']} ${classes['medical']}`} />
              <span className='title__x-small ps-1'>{chartData[0]?.name}</span>
            </span>
            <span className='title__bold title__x-small text-nowrap ps-4'>
              <span> - &nbsp;{`${chartData[0]?.value}%`} </span>
              <span className='ps-1 pe-1'>|</span>
              <span>
                {numberToShortNumFormatter(chartData[0]?.livesNumber, 2)}
              </span>
            </span>
          </span>

          <span
            className={`${classes['chart-label']} d-flex align-items-center`}>
            <span className='d-flex align-items-center'>
              <div className={`${classes['circle']} ${classes['pharmacy']}`} />
              <span className=' title__x-small ps-1'>{chartData[1]?.name}</span>
            </span>
            <span className='title__bold title__x-small text-nowrap ps-4'>
              <span> - &nbsp;{`${chartData[1]?.value}%`} </span>
              <span className='ps-1 pe-1'>|</span>
              {numberToShortNumFormatter(chartData[1]?.livesNumber, 2)}
            </span>
          </span>
        </div>
      </Col>

      <Spinner area={areas.bannerSegment} />
    </Row>
  );
};

export default McoGaugeChart;
